<template>
    <div>
        <card title="Provider Web Management">
            <b-tabs pills>
                <b-tab title="Management" active>
                    <div class="pt-3">
            <b-row>
                <b-col class="col-4">
                    <Card plain>
                        <h6>Announcements</h6>

                        <card plain>
                            <b-form-textarea v-model="announcement.body" class="textarea-autosize" placeholder="Enter new Announcement" rows="8"
                                max-rows="8" />
                            <br />
                            <b-row>
                                <b-col>
                                    <vue-dropzone id="dropzone" ref="myVueDropzone" :options="dropzoneOptions"
                                        @vdropzone-success="dropzoneUploadSuccess"
                                        @vdropzone-sending="dropzoneSending"
                                        @vdropzone-error="dropzoneError" />
                                </b-col>
                            </b-row>
                            <div v-if="announcement.id && announcement.imageUrl" class="mt-2 mb-2">
                                <b-img :src="announcement.imageUrl" fluid thumbnail />
                                <b-button size="sm" variant="outline-danger" block class="mt-1"
                                    @click="removeAnnouncementImage">
                                    Remove image
                                </b-button>
                            </div>
                            <b-form-group class="mt-2 mb-2" label="End date (optional)"
                                description="The announcement stops showing in the provider portal once this date passes.">
                                <b-form-datepicker v-model="announcement.endDate" reset-button
                                    placeholder="No end date" />
                            </b-form-group>
                            <b-button variant="success" block @click="SubmitNewAnnouncement">
                                <strong>
                                    {{ announcement.id ? 'Update Announcement' : 'Send Announcement' }}
                                </strong>
                            </b-button>
                            <b-button v-if="announcement.id" variant="link" block class="mt-1"
                                @click="cancelEditAnnouncement">
                                Cancel edit
                            </b-button>
                        </card>

                        <div class="mb-1">
                            <a href="#" @click.prevent="showPreviousAnnouncements = !showPreviousAnnouncements">
                                <i :class="{ 'fa fa-fw': true, 'fa-chevron-right': true, 'fa-rotate-90': showPreviousAnnouncements }"
                                    aria-hidden="true" style="transition: all .2s;"></i>
                                <strong>Previous Announcements</strong>
                            </a>
                        </div>

                        <b-collapse :visible="showPreviousAnnouncements">
                            <Card plain v-for="a in announcements" :key="a.id" class="mb-2">
                                <b-row>
                                    <b-col>
                                        {{ a.body }}
                                        <b-img v-if="a.imageUrl" :src="a.imageUrl" fluid />
                                        <div v-if="a.endDate" class="small text-muted mt-1">
                                            Ends: {{ formatEndDate(a.endDate) }}
                                        </div>
                                    </b-col>
                                    <b-col cols="auto" class="text-right">
                                        <b-button size="sm" variant="outline-primary" class="mb-1"
                                            @click="editAnnouncement(a)">
                                            Edit
                                        </b-button>
                                        <b-button size="sm" variant="outline-danger"
                                            @click="removeAnnouncement(a)">
                                            Remove
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </Card>
                        </b-collapse>

                    </Card>
                </b-col>
                <b-col>
                    <Card plain>
                        <h6>Practice Management</h6>
                        <b-row>
                            <b-col>
                                <fg-input class="mt-2" v-model="newPracticeName" placeholder="New Practice Name (required)" />
                            </b-col>
                            <b-button variant="success" @click="SubmitNewPractice" class="mr-3">
                                Add Practice
                            </b-button>
                        </b-row>
                        <b-table id="practices-table" style="cursor:pointer" striped responsive="true" sort-icon-left
                            :items="practices" :fields="practiceFields" @row-clicked="selectPractice" :current-page="pageNumber"
                            :per-page="pageSize">
                            <template #cell(isActive)="data">
                                <b-form-checkbox switch v-model="data.item.isActive"
                                    @change="togglePracticeActive(data.item)" @click.native.stop />
                            </template>
                        </b-table>
                        <BottomPagerBar v-model="pageNumber" :total-rows="practices.length" item-name="practice"
                            :current-page="pageNumber" :per-page="pageSize" show-page-size-selector
                            @change-page-size="pageSize = $event" />
                    </Card>
                </b-col>
            </b-row>
                    </div>
                </b-tab>
                <b-tab title="Access Logs">
                    <div class="pt-3">
                        <UserAccessLogReport endpoint-base="/api/ProviderWeb/access-logs" :show-client="true"
                            :show-role="false" :show-zone="false" />
                    </div>
                </b-tab>
            </b-tabs>
        </card>

        <b-modal id="doctorSearchModal" title="Prescriber Search" size="xl" @ok="selectDoc">
            <NameSearchComponent v-model="displayName" :named-person="doctor" search-mode
                @person-update="personUpdate" />
        </b-modal>

        <b-modal id="practiceDetailModal" title="Practice Info" size="xl" @hide="getPractices">
            <b-row>
                <b-col class="col-3">
                    <Card>
                        <b>Name: </b>{{ selectedPractice.name }}<br />
                        <b>Doctor Count: </b> {{ practiceDoctors.length }}<br />
                        <b>User Count: </b> {{ practiceUsers.length }}<br />
                        <hr />
                        <b-form-checkbox switch v-model="selectedPractice.showCoverMyMedsLink"
                            @change="updatePracticeSettings(selectedPractice)">
                            Show CoverMyMeds Link
                        </b-form-checkbox>
                        <hr />
                        <b-button variant="success" size="sm" @click="editModeChange('user')">Add User</b-button>
                        <b-button variant="info" size="sm" @click="editModeChange('doctor')">Add Doctor</b-button>
                    </Card>

                    <Card v-if="editMode == 'user'">
                        <h6>{{ editMode }} Creation</h6>
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.email" placeholder="Email (required)" />
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.firstName" placeholder="First Name (required)" />
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.lastName" placeholder="Last Name (required)" />
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.phoneNumber"
                            placeholder="Phone Number (+1XXXXXXXXXX) (required)" />
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.address1" placeholder="Address Line 1" />
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.address2" placeholder="Address Line 2" />
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.city" placeholder="City" />
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.state" placeholder="State" />
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.postalCode" placeholder="Postal Code" />
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.npiNumber" placeholder="NPI" />

                        <label v-if="editMode == 'user'">
                            <input type="checkbox" v-model="newPerson.canPrescribe">
                            &nbsp;Can Prescribe
                            </input>
                        </label>

                        <div class="pt-1">
                            <b-button variant="success" size="sm" @click="submitEdit" block>
                                Create
                            </b-button>
                        </div>
                    </Card>
                </b-col>
                <b-col>
                    <h6>Users</h6>
                    <b-spinner v-if="loadingUsers" />
                    <b-table v-else id="practices-table" style="cursor:pointer" striped responsive="true" sort-icon-left
                        :items="practiceUsers" :fields="userFields">
                        <template #cell(canPrescribe)="data">
                            <b-form-checkbox switch v-model="data.item.canPrescribe"
                                @change="updateUser(data.item)" />
                        </template>
                        <template #cell(resend)="data">
                            <b-icon icon="envelope-fill" v-b-tooltip.hover title="Resend Welcome Email" variant="info"
                                style="cursor: pointer" @click="resendWelcomeEmail(data.item)">
                            </b-icon>
                        </template>
                        <template #cell(remove)="data">
                            <b-icon icon="x-circle-fill" v-b-tooltip.hover title="Remove" variant="danger"
                                style="cursor: pointer" @click="removeUser(data.item)">
                            </b-icon>
                        </template>
                    </b-table>

                    <h6>Doctors</h6>
                    <b-spinner v-if="loadingDoctors" />
                    <b-table v-else id="practices-table" style="cursor:pointer" striped responsive="true" sort-icon-left
                        :items="practiceDoctors" :fields="doctorFields">
                        <template #cell(name)="data">
                            <span>{{ data.item.lastName }}, {{ data.item.firstName }}</span>
                        </template>
                        <template #cell(remove)="data">
                            <b-icon icon="x-circle-fill" v-b-tooltip.hover title="Remove" variant="danger"
                                style="cursor: pointer" @click="removeDoctor(data.item)">
                            </b-icon>
                        </template>
                    </b-table>

                    <h6>Tasks</h6>
                    <b-spinner v-if="loadingTasks" />
                    <b-table v-else :items="practiceTasks" :fields="taskFields" show-empty empty-text="No tasks found">
                        <template #cell(startDate)="data">
                            <span>{{ data.item.startDate | formatDate('L') }}</span>
                        </template>
                        <template #cell(dueDate)="data">
                            <span>{{ data.item.dueDate | formatDate('L') }}</span>
                        </template>
                        <template #cell(status)="data">
                            <b-badge :variant="data.item.status === 0 ? 'primary' : data.item.status === 1 ? 'warning' : 'success'">
                                {{ data.item.status === 0 ? 'New' : data.item.status === 1 ? 'In Progress' : 'Complete' }}
                            </b-badge>
                        </template>
                    </b-table>

                    <h6>Groups</h6>
                    <b-spinner v-if="loadingGroups" />
                    <div v-else>
                        <b-row class="mb-2 align-items-center" no-gutters>
                            <b-col>
                                <b-form-input v-model="newGroupName" placeholder="New Group Name" size="sm" />
                            </b-col>
                            <b-col cols="auto" class="pl-2">
                                <b-button variant="success" size="sm" @click="createGroup">Add Group</b-button>
                            </b-col>
                        </b-row>
                        <div v-for="group in practiceGroups" :key="group.id" class="mb-3 border rounded p-2">
                            <b-row class="align-items-center mb-2">
                                <b-col><strong>{{ group.name }}</strong></b-col>
                                <b-col cols="auto">
                                    <b-icon icon="x-circle-fill" v-b-tooltip.hover title="Delete Group" variant="danger"
                                        style="cursor: pointer" @click="deleteGroup(group)" />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <small class="text-muted d-block mb-1">Doctors</small>
                                    <b-list-group flush class="mb-1">
                                        <b-list-group-item v-for="npi in group.doctorNPIs" :key="npi"
                                            class="d-flex justify-content-between align-items-center py-1 px-2">
                                            <span>{{ doctorLabel(npi) }}</span>
                                            <b-icon icon="x" style="cursor:pointer" variant="danger"
                                                @click="toggleGroupDoctor(group, { npiNumber: npi })" />
                                        </b-list-group-item>
                                    </b-list-group>
                                    <b-form-select size="sm" :value="null"
                                        @change="(npi) => npi && toggleGroupDoctor(group, { npiNumber: npi })">
                                        <option :value="null" disabled>— Add doctor —</option>
                                        <option v-for="doc in practiceDoctors.filter(d => !group.doctorNPIs.includes(d.npiNumber))"
                                            :key="doc.npiNumber" :value="doc.npiNumber">
                                            {{ doc.lastName }}, {{ doc.firstName }}
                                        </option>
                                    </b-form-select>
                                </b-col>
                                <b-col>
                                    <small class="text-muted d-block mb-1">Users</small>
                                    <b-list-group flush class="mb-1">
                                        <b-list-group-item v-for="username in group.usernames" :key="username"
                                            class="d-flex justify-content-between align-items-center py-1 px-2">
                                            <span>{{ username }}</span>
                                            <b-icon icon="x" style="cursor:pointer" variant="danger"
                                                @click="toggleGroupUser(group, { username })" />
                                        </b-list-group-item>
                                    </b-list-group>
                                    <b-form-select size="sm" :value="null"
                                        @change="(u) => u && toggleGroupUser(group, { username: u })">
                                        <option :value="null" disabled>— Add user —</option>
                                        <option v-for="user in practiceUsers.filter(u => !group.usernames.includes(u.username))"
                                            :key="user.username" :value="user.username">
                                            {{ user.username }}
                                        </option>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                        </div>
                        <div v-if="!practiceGroups.length" class="text-muted small">No groups configured. All users see all practice data.</div>
                    </div>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script lang="ts">
import Axios, { AxiosError } from 'axios';
import { Component, Mixins, Watch } from 'vue-property-decorator';
import DisableAutocompleteMixin from '@/mixins/DisableAutocompleteMixin';
import Vue2Dropzone from 'vue2-dropzone';
import SearchComponent from '@/components/SearchComponent.vue';
import EnumSelector from '@/components/EnumSelector.vue';
import Checkbox from "@/components/Inputs/Checkbox.vue";
import NewClearSaveButtons from '@/components/NewClearSaveButtons.vue';
import NameSearchComponent from '@/components/NameSearchComponent.vue';
import { NotificationOptions } from "@/util/NotificationOptionsPresets";
import { PracticeResult, ProviderWebPerson, AnnouncementResult, Announcement } from "@/models/ProviderWeb";
import { Prescriber } from "@/models/Prescriber";
import BottomPagerBar from '@/components/BottomPagerBar.vue';
import UserAccessLogReport from '@/components/UserAccessLogReport.vue';
import { getPageSizePreference, savePageSizePreference } from '@/util/pageSizePreference';

@Component({
    name: 'ProviderWebPage',
    components: {
        SearchComponent,
        Checkbox,
        NewClearSaveButtons,
        EnumSelector,
        NameSearchComponent,
        "VueDropzone": Vue2Dropzone,
        BottomPagerBar,
        UserAccessLogReport
    },
})
export default class ProviderWebPage extends Mixins(DisableAutocompleteMixin) {

    protected practices: PracticeResult[] = [];
    private selectedPractice: PracticeResult = {} as PracticeResult;
    protected practiceDoctors: ProviderWebPerson[] = [];
    protected practiceUsers: ProviderWebPerson[] = [];
    protected practiceTasks: any[] = [];
    protected practiceGroups: any[] = [];
    private newGroupName = "";
    private editMode: string | null = null;
    private newPerson: ProviderWebPerson = {} as ProviderWebPerson;
    private doctor: Prescriber = new Prescriber();
    private displayName = "";
    private newPracticeName = "";
    private announcement: AnnouncementResult = {} as AnnouncementResult;
    protected announcements: Announcement[] = [];

    protected pageNumber = 1;
    protected pageSize = 50;

    protected loadingUsers = false;
    protected loadingDoctors = false;
    protected loadingTasks = false;
    protected loadingGroups = false;

    protected showPreviousAnnouncements = false;

    private practiceFields = [
        { key: 'name', sortable: true },
        { key: 'userCount', label: 'User Count', sortable: true },
        { key: 'doctorCount', label: 'Doctor Count', sortable: true },
        { key: 'isActive', label: 'Active', sortable: true },
    ];

    private userFields = [
        { key: 'username', sortable: true },
        { key: 'email', sortable: true },
        { key: 'canPrescribe', label: 'Can Prescribe', sortable: true },
        { key: "resend", label: "" },
        { key: "remove", label: "" },
    ];

    private doctorFields = [
        { key: 'name', sortable: true },
        { key: 'npiNumber', sortable: true },
        { key: "remove", label: "" },
    ];

    private taskFields = [
        { key: 'title', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'startDate', label: 'Start Date', sortable: true },
        { key: 'dueDate', label: 'Due Date', sortable: true },
    ];

    created() {
        this.pageSize = getPageSizePreference(this, 'pageSize_ProviderWeb', 50);
        this.getPractices();
        this.getAnnouncements();
    }

    @Watch("pageSize")
    onPageSizeChanged() {
        savePageSizePreference(this, 'pageSize_ProviderWeb', this.pageSize);
    }

    // dropzone
    // properties
    get dropzoneOptions(): any {
        return {
            url: `${Axios.defaults.baseURL}/image/ProviderWeb`,
            thumbnailWidth: 150,
            withCredentials: true,
            paramName: 'images',
            maxFiles: 1,
            addRemoveLinks: true,
        };
    }

    // events
    dropzoneSending(file: any, xhr: XMLHttpRequest, _formData: FormData) {
        const authHeader = Axios.defaults.headers["Authorization"]?.toString() ?? "";
        xhr.setRequestHeader("Authorization", authHeader);
    }

    dropzoneUploadSuccess(file: any, response: any) {
        this.announcement.imageUrl = response;
    }

    dropzoneError(file: any, message: any, xhr: any) {
        console.error("Dropzone upload error:", { file: file.name, message, status: xhr?.status, response: xhr?.responseText });
        this.$notification(NotificationOptions.error(`Image upload failed: ${typeof message === 'string' ? message : message?.message || 'Unknown error'}`));
    }

    selectPractice(practice: any) {
        this.$bvModal.show('practiceDetailModal');
        this.selectedPractice = practice;

        this.getPracticeUsers();
        this.getPracticeDoctors();
        this.getPracticeTasks();
        this.getPracticeGroups();
    }

    async getAnnouncements() {
        try {
            const response = await Axios.get<Announcement[]>('api/ProviderWeb/Announcement');
            this.announcements = response.data;
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
    }

    async getPractices() {
        try {
            let response = await Axios.get<PracticeResult[]>('api/ProviderWeb/Practices/All');
            this.practices = response.data;
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
    }

    async getPracticeUsers() {
        try {
            this.loadingUsers = true;
            this.practiceUsers = [];
            const response = await Axios.get(`/ProviderWeb/Practices/Users/${this.selectedPractice.id}`);
            this.practiceUsers = response.data;
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        } finally {
            this.loadingUsers = false;
        }
    }

    async getPracticeDoctors() {
        try {
            this.loadingDoctors = true;
            this.practiceDoctors = [];
            const response = await Axios.get(`/ProviderWeb/Practices/Doctors/${this.selectedPractice.id}`);
            this.practiceDoctors = response.data;
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        } finally {
            this.loadingDoctors = false;
        }
    }

    async getPracticeTasks() {
        try {
            this.loadingTasks = true;
            this.practiceTasks = [];
            const response = await Axios.get(`api/ProviderWeb/Practices/${this.selectedPractice.id}/Tasks`);
            this.practiceTasks = response.data;
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        } finally {
            this.loadingTasks = false;
        }
    }

    async getPracticeGroups() {
        try {
            this.loadingGroups = true;
            this.practiceGroups = [];
            const response = await Axios.get(`api/ProviderWeb/Practices/${this.selectedPractice.id}/Groups`);
            const groups = (response.data ?? []).map((g: any) => ({ ...g, doctorNPIs: [] as string[], usernames: [] as string[] }));
            await Promise.all(groups.map(async (group: any) => {
                const [docRes, userRes] = await Promise.all([
                    Axios.get(`api/ProviderWeb/Practices/${this.selectedPractice.id}/Groups/${group.id}/Doctors`).catch(() => ({ data: [] })),
                    Axios.get(`api/ProviderWeb/Practices/${this.selectedPractice.id}/Groups/${group.id}/Users`).catch(() => ({ data: [] })),
                ]);
                group.doctorNPIs = docRes.data ?? [];
                group.usernames = userRes.data ?? [];
            }));
            this.practiceGroups = groups;
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        } finally {
            this.loadingGroups = false;
        }
    }

    isInGroup(group: any, type: 'doctor' | 'user', value: string): boolean {
        if (type === 'doctor') return (group.doctorNPIs ?? []).includes(value);
        return (group.usernames ?? []).includes(value);
    }

    doctorLabel(npi: string): string {
        const doc = this.practiceDoctors.find((d: any) => d.npiNumber === npi);
        return doc ? `${doc.lastName}, ${doc.firstName}` : npi;
    }

    async toggleGroupDoctor(group: any, doc: any) {
        const npi = doc.npiNumber;
        const inGroup = this.isInGroup(group, 'doctor', npi);
        try {
            if (inGroup) {
                await Axios.delete(`api/ProviderWeb/Practices/${this.selectedPractice.id}/Groups/${group.id}/Doctors/${npi}`);
                group.doctorNPIs = (group.doctorNPIs ?? []).filter((n: string) => n !== npi);
            } else {
                await Axios.post(`api/ProviderWeb/Practices/${this.selectedPractice.id}/Groups/${group.id}/Doctors`, { value: npi });
                group.doctorNPIs = [...(group.doctorNPIs ?? []), npi];
            }
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
    }

    async toggleGroupUser(group: any, user: any) {
        const username = user.username;
        const inGroup = this.isInGroup(group, 'user', username);
        try {
            if (inGroup) {
                await Axios.delete(`api/ProviderWeb/Practices/${this.selectedPractice.id}/Groups/${group.id}/Users/${username}`);
                group.usernames = (group.usernames ?? []).filter((u: string) => u !== username);
            } else {
                await Axios.post(`api/ProviderWeb/Practices/${this.selectedPractice.id}/Groups/${group.id}/Users`, { value: username });
                group.usernames = [...(group.usernames ?? []), username];
            }
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
    }

    async createGroup() {
        if (!this.newGroupName?.trim()) {
            this.$notification(NotificationOptions.error("Group name is required"));
            return;
        }
        try {
            await Axios.post(`api/ProviderWeb/Practices/${this.selectedPractice.id}/Groups`, { name: this.newGroupName });
            this.newGroupName = "";
            await this.getPracticeGroups();
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
    }

    async deleteGroup(group: any) {
        try {
            await Axios.delete(`api/ProviderWeb/Practices/${this.selectedPractice.id}/Groups/${group.id}`);
            await this.getPracticeGroups();
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
    }

    editModeChange(chosenMode: string) {
        if (chosenMode != this.editMode) {
            this.newPerson = {} as ProviderWebPerson;
        }
        this.editMode = chosenMode;
        if (chosenMode == 'doctor') {
            this.$bvModal.show('doctorSearchModal');
        }

    }

    async submitEdit() {
        if (this.editMode != 'user') return;

        if (!this.newPerson.email?.trim()) {
            this.$notification(NotificationOptions.error("Email is required"));
            return;
        }

        if (!this.newPerson.firstName?.trim()) {
            this.$notification(NotificationOptions.error("First Name is required"));
            return;
        }

        if (!this.newPerson.lastName?.trim()) {
            this.$notification(NotificationOptions.error("Last Name is required"));
            return;
        }

        if (!this.newPerson.phoneNumber?.trim()) {
            this.$notification(NotificationOptions.error("Phone Number is required. Format must be +1XXXXXXXXXX"));
            return;
        }

        if (this.newPerson.canPrescribe) {
            if (!this.newPerson.npiNumber?.trim()) {
                this.$notification(NotificationOptions.error("NPI is required when 'Can Prescribe' is selected"));
                return;
            }

            if (!/^\d{10}$/.test(this.newPerson.npiNumber.trim())) {
                this.$notification(NotificationOptions.error("NPI must be exactly 10 digits"));
                return;
            }
        }

        try {
            await Axios.post(`/ProviderWeb/Practices/${this.selectedPractice.id}/CreateUser`, this.newPerson);
            this.newPerson = {} as ProviderWebPerson;
            this.getPracticeUsers();
            this.$notification(NotificationOptions.success("Created new user"));
        } catch (error) {
            const err = error as AxiosError;
            const errorMessage = err.response?.data || err.message || "Failed to create user";
            this.$notification(NotificationOptions.error(errorMessage));
        }
    }

    async selectDoc() {
        this.newPerson.npiNumber = this.doctor.npiNumber;
        this.newPerson.practiceId = this.selectedPractice.id;
        try {
            await Axios.post(`/ProviderWeb/Practices/AddDoctor`, this.newPerson);
            await this.getPracticeDoctors();
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
    }

    personUpdate(value: any) {
        this.doctor = value;
    }

    async resendWelcomeEmail(user: any) {
        try {
            await Axios.post(`/ProviderWeb/Practices/${this.selectedPractice.id}/ResendWelcomeEmail`, {
                username: user.username
            });
            this.$notification(NotificationOptions.success("Welcome email resent successfully"));
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
    }

    async updateUser(user: any) {
        try {
            await Axios.post(`/ProviderWeb/Practices/${this.selectedPractice.id}/UpdateUser`, user);
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
    }

    async removeUser(user: any) {
        console.log(user);
        try {
            await Axios.post(`/ProviderWeb/Practices/${this.selectedPractice.id}/DeleteUser`, user);
            await this.getPracticeUsers();
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
    }

    async removeDoctor(doctor: any) {
        doctor.practiceId = this.selectedPractice.id;
        try {
            await Axios.post(`/ProviderWeb/Practices/DeleteDoctor`, doctor);
            await this.getPracticeDoctors();
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
    }

    async togglePracticeActive(practice: PracticeResult) {
        try {
            await Axios.post(`/ProviderWeb/Practices/${practice.id}/SetActive`, { isActive: practice.isActive });
        } catch (error) {
            practice.isActive = !practice.isActive;
            this.$notification(NotificationOptions.error(error));
        }
    }

    async updatePracticeSettings(practice: PracticeResult) {
        try {
            await Axios.put(`api/ProviderWeb/Practices/${practice.id}/Settings`, { showCoverMyMedsLink: practice.showCoverMyMedsLink });
            this.$notification(NotificationOptions.success("Practice settings updated"));
        } catch (error) {
            practice.showCoverMyMedsLink = !practice.showCoverMyMedsLink;
            this.$notification(NotificationOptions.error(error));
        }
    }

    async SubmitNewPractice() {
        if (!this.newPracticeName?.trim()) {
            this.$notification(NotificationOptions.error("Practice Name Required"));
            return;
        }

        try {
            await Axios.post(`/ProviderWeb/Practices/New/${this.newPracticeName}`);
            await this.getPractices();
            this.newPracticeName = "";
        } catch (error) {
            const err = error as AxiosError;
            const errorMessage = err.response?.data || err.message || "Failed to create practice";
            this.$notification(NotificationOptions.error(errorMessage));
        }
    }

    async SubmitNewAnnouncement() {
        const isEdit = !!this.announcement.id;
        // The date picker yields '' when cleared; send null so the optional EndDate
        // deserializes correctly server-side (an empty string is not a valid DateTime).
        if (!this.announcement.endDate) {
            this.announcement.endDate = null;
        }
        try {
            // The upsert endpoint handles both create and edit (existing Id).
            await Axios.post(`/ProviderWeb/Announcement`, this.announcement);
            this.announcement = {} as AnnouncementResult;

            // Clear the dropzone after successful submission
            const dropzone: any = this.$refs.myVueDropzone;
            if (dropzone) {
                dropzone.removeAllFiles();
            }

            this.$notification(NotificationOptions.success(isEdit ? "Updated announcement" : "Posted announcement"));
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
        await this.getAnnouncements();
    }

    // Load an existing announcement into the form so the next submit upserts it by Id.
    editAnnouncement(a: Announcement) {
        this.announcement = {
            id: a.id,
            body: a.body,
            imageUrl: a.imageUrl,
            author: "", // set server-side from the signed-in user; value here is ignored
            posted: a.posted,
            endDate: a.endDate ? a.endDate.substring(0, 10) : null,
        };
        this.showPreviousAnnouncements = true;
    }

    cancelEditAnnouncement() {
        this.announcement = {} as AnnouncementResult;
        const dropzone: any = this.$refs.myVueDropzone;
        if (dropzone) {
            dropzone.removeAllFiles();
        }
    }

    // Clear the image on the announcement being edited. The upsert writes ImageUrl
    // unconditionally, so submitting with an empty value removes the stored image.
    removeAnnouncementImage() {
        this.announcement.imageUrl = "";
        const dropzone: any = this.$refs.myVueDropzone;
        if (dropzone) {
            dropzone.removeAllFiles();
        }
    }

    async removeAnnouncement(a: Announcement) {
        const confirmed = await this.$bvModal.msgBoxConfirm(
            "Remove this announcement? It will no longer appear in the provider portal.",
            { okVariant: "danger", okTitle: "Remove", cancelTitle: "Cancel" });
        if (!confirmed) return;
        try {
            await Axios.delete(`/ProviderWeb/Announcement/${a.id}`);
            // If the removed announcement was loaded for editing, clear the form.
            if (this.announcement.id === a.id) {
                this.cancelEditAnnouncement();
            }
            this.$notification(NotificationOptions.success("Removed announcement"));
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
        await this.getAnnouncements();
    }

    formatEndDate(endDate: string): string {
        return new Date(endDate).toLocaleDateString();
    }
} // close export of class
</script>

<style scoped></style>
